module.exports = "<svg viewBox=\"0 0 20 16.5\"><path fill=\"#231F20\" d=\"M13.2 16.5c-.2 0-.4-.1-.6-.2-.4-.3-.5-1-.2-1.4l4.5-5.6H1c-.6 0-1-.4-1-1s.4-1 1-1h18c.4 0 .7.2.9.6.2.3.1.8-.1 1.1L14 16.1c-.2.2-.5.4-.8.4z\"></path><path fill=\"#231F20\" d=\"M19 9.2c-.3 0-.6-.1-.8-.4l-5.8-7.2c-.3-.4-.3-1.1.2-1.4.4-.3 1-.3 1.4.2l5.8 7.2c.3.5.2 1.1-.2 1.4-.2.2-.4.2-.6.2z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/arrow.svg
// module id = 294
// module chunks = 1